import { useState } from 'react'
import Styles from '../../AutopilotPlansModal.module.scss'
import { Modal } from 'almanac-ui/Modal'
import { SelectedPlanForm } from './components/SelectedPlanForm/SelectedPlanForm'
import { AutopilotPlan, StripePrice } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'
import { OnStartPlan } from '../../AutopilotPlansModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const Form = ({
  onBack,
  onChangePlan,
  selectedPlan,
  onStartPlan,
  currentPrice,
  initialSelectedPrice,
  shouldAutoReloadCredits,
  toggleAutoReloadCredits,
  initialIsCheckoutStep = false,
}: {
  onBack: () => void
  onChangePlan: () => void
  onStartPlan: OnStartPlan
  selectedPlan: AutopilotPlan
  currentPrice: StripePrice | null
  initialSelectedPrice?: StripePrice
  shouldAutoReloadCredits: boolean
  toggleAutoReloadCredits: () => void
  initialIsCheckoutStep?: boolean
}) => {
  const { isMobile } = useResponsiveDesign()
  const isVerticalPlanLength = useFlipperFlag('vertical_plan_length')
  const [isCheckoutStep, setIsCheckoutStep] = useState(initialIsCheckoutStep)

  const handleHeaderBack = () => {
    if (isVerticalPlanLength && isCheckoutStep && !initialIsCheckoutStep) {
      setIsCheckoutStep(false)
    } else {
      onBack()
    }
  }

  const getHeaderTitle = () => {
    if (isVerticalPlanLength && isCheckoutStep) return 'Checkout'
    if (isVerticalPlanLength) return 'Change plan length'
    return 'Choose your plan length'
  }

  return (
    <>
      <Modal.Header preventClose={isMobile} title={getHeaderTitle()} />
      <Modal.Content className={Styles.content} withoutFooter>
        <SelectedPlanForm
          selectedPlan={selectedPlan}
          currentPrice={currentPrice}
          initialSelectedPrice={initialSelectedPrice}
          onBack={handleHeaderBack}
          onChangePlan={onChangePlan}
          onStartPlan={onStartPlan}
          shouldAutoReloadCredits={shouldAutoReloadCredits}
          toggleAutoReloadCredits={toggleAutoReloadCredits}
          isCheckoutStep={isCheckoutStep}
          setIsCheckoutStep={setIsCheckoutStep}
        />
      </Modal.Content>
    </>
  )
}
